import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useUser } from '@repo/hooks/useUser';

const RedirectToAccountOverview = () => {
  const user = useUser();
  const userAccountId = user.account.id;

  const navigate = useNavigate();
  useEffect(() => {
    navigate(`/a/${userAccountId}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default RedirectToAccountOverview;
